const DATE = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "short",
  day: "2-digit",
});

const DATE_TIME = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

function parse(iso: string): Date | null {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(iso: string): string {
  const date = parse(iso);
  return date ? DATE.format(date) : iso;
}

export function formatDateTime(iso: string): string {
  const date = parse(iso);
  return date ? DATE_TIME.format(date) : iso;
}

const USD = new Intl.NumberFormat(undefined, {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

export function formatUsd(amount: number): string {
  return USD.format(amount);
}

/**
 * A 2dp USD string off the wire (the portfolio and activity endpoints serve
 * money as decimal strings). Parsed only for display; nothing is summed here.
 */
export function formatUsdString(amount: string): string {
  const n = Number(amount);
  return Number.isFinite(n) ? USD.format(n) : amount;
}

export function formatCount(count: number): string {
  return new Intl.NumberFormat().format(count);
}

/** Falls back to an em-space placeholder so table cells never collapse. */
export function orDash(value: string | null | undefined): string {
  return value && value.length > 0 ? value : "—";
}

/**
 * How long before the request the current phone was last used. The signal
 * that matters most: a phone seen minutes before someone reports it lost
 * deserves a second look. Seen AFTER the request is stranger still, and says
 * so rather than printing a negative gap.
 */
export function lastSeenGap(lastSeenAt: string, requestedAt: string): string {
  const diff = Date.parse(requestedAt) - Date.parse(lastSeenAt);
  const minutes = Math.floor(Math.abs(diff) / 60_000);
  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);
  const mins = minutes % 60;
  const span =
    days > 0 ? `${days}d ${hours}h` : hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
  return diff >= 0 ? `${span} before request` : `${span} after request`;
}
